import { ComponentInterface, Entity } from '@goodboydigital/odie';
import { Rectangle } from 'pixi.js';

import { BaseEntity } from '../entities/BaseEntity';
import { Game } from '../Game';

export class CullingComponent implements ComponentInterface
{
    public bounds?: Rectangle;
    public entity!: BaseEntity;

    constructor()
    {
        //
    }

    public addedToEntity(en: Entity): void
    {
        this.entity = en as BaseEntity;
    }

    /** Update view bounds relative to 0 position, with am optional safe scale */
    public updateBounds(scale = 1): void
    {
        if (!this.entity) return;
        this.entity.view.x = this.entity.view.y = 0;
        this.bounds = this.entity.view.getBounds();
        this.bounds.x *= scale;
        this.bounds.y *= scale;
        this.bounds.width *= scale;
        this.bounds.height *= scale;
        this.entity.view.visible = false;
    }

    public render(): void
    {
        if (!this.bounds || !this.entity || !this.entity.scene) return;
        const camera = (this.entity.scene as Game).camera;
        const l = this.entity.view.position.x + this.bounds.x;
        const r = l + this.bounds.width;
        const t = this.entity.view.position.y + this.bounds.y;
        const b = t + this.bounds.height;
        const visible = r > camera.left && l < camera.right && t < camera.bottom && b > camera.top;

        if (visible && !this.entity.view.visible)
        {
            this.entity.view.visible = true;
            this.entity.view.updateTransform();
        }
        else if (!visible && this.entity.view.visible)
        {
            this.entity.view.visible = false;
        }
    }
}
